import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { WarningIcon } from '@phosphor-icons/react/Warning';
import { WarningCircleIcon } from '@phosphor-icons/react/WarningCircle';
import { useTranslation } from 'react-i18next';
import { getExpireSoonTitle } from '../../utils/getExpireSoonTitle.ts';

type BaseProps = {
  showArchived?: boolean;
  showExpired?: boolean;
};

type ExpireSoonFalse = {
  showExpireSoon?: false;
  segmentDaysRemaining?: never;
};

type ExpireSoonTrue = {
  showExpireSoon: true;
  segmentDaysRemaining: number;
};

export type SegmentAlertProps = BaseProps & (ExpireSoonFalse | ExpireSoonTrue);

export const SegmentAlert = ({
  showArchived,
  showExpired,
  showExpireSoon,
  segmentDaysRemaining,
}: SegmentAlertProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (showArchived) {
    return (
      <Tooltip title={t('Segment is archived and cannot be used for audience creation')}>
        <WarningCircleIcon size={20} color={theme.palette.error.main} data-test="archived-alert" />
      </Tooltip>
    );
  }

  if (showExpired) {
    return (
      <Tooltip title={t('Segment data is expired and cannot be used for audience creation')}>
        <WarningCircleIcon size={20} color={theme.palette.error.main} data-test="expired-icon" />
      </Tooltip>
    );
  }

  if (showExpireSoon) {
    return (
      <Tooltip title={getExpireSoonTitle(t, segmentDaysRemaining)}>
        <WarningIcon size={20} color={theme.palette.warning.main} data-test="expire-soon-icon" />
      </Tooltip>
    );
  }

  return null;
};
